var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"check_box",class:{checked:_vm.checked, disabled: _vm.disabled},on:{"click":_vm.check}},[_c('span',{staticClass:"iconfont icongou"})])}
var staticRenderFns = []

export { render, staticRenderFns }